import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    ListItem,
    LabelWrapper,
    ActionsWrapper,
    DragAndDropIconWrapper,
    ChevronIconWrapper,
    MovableSpan,
    ToggleWrapper,
} from 'src/domains/layouts/shared/cms/list/List.style';
import { MoreActions } from 'src/domains/layouts/shared/moreActions/MoreActions';

interface ListItemPrimaryPropsType {
    label: string;
    setPublished: () => Promise<void>;
    isPublished: boolean;
    isEdited?: boolean;
    handleDragAndDrop?: boolean;
    hasSubsection?: boolean;
    subsection?: 'one' | 'two';
    isDragged?: boolean;
    handleToggleOpenSection?: () => void;
    isOpenSection?: boolean;
    handleEdit?: () => void;
    handleDuplicate?: () => void;
    handleDelete: () => void;
    showDeletePopup?: boolean;
    handleHideDeletePopup?: () => void;
    handleShowDeletePopup?: () => void;
    dataTest?: string;
}

export const ListItemSecondary = observer('ListItemSecondary', (propsIn: ListItemPrimaryPropsType) => {
    const {
        label,
        setPublished,
        isPublished,
        isEdited,
        isDragged,
        hasSubsection,
        subsection,
        handleToggleOpenSection,
        isOpenSection,
        handleEdit,
        handleDuplicate,
        handleDragAndDrop,
        handleDelete,
        showDeletePopup,
        handleHideDeletePopup,
        handleShowDeletePopup,
        dataTest,
    } = propsIn;

    return (
        <ListItem
            direction='row'
            subsection={subsection}
            isDragged={isDragged}
            isEdited={isEdited}
            data-test={dataTest}
        >
            <LabelWrapper
                hasSubsection={hasSubsection}
                subsection={subsection}
            >
                {handleDragAndDrop === true ? (
                    <MovableSpan data-movable-handle>
                        <DragAndDropIconWrapper
                            subsection={subsection}
                            isDragged={isDragged ?? false}
                        />
                    </MovableSpan>
                ) : null}
                {handleToggleOpenSection === undefined ? (
                    label
                ) : (
                    <>
                        <ChevronIconWrapper
                            position={isOpenSection === true ? 'down' : 'right'}
                            subsection={subsection}
                            onClick={handleToggleOpenSection}
                            dataTest='chevron'
                        />
                        <span onClick={handleToggleOpenSection}>{label}</span>
                    </>
                )}
            </LabelWrapper>

            <ActionsWrapper>
                <ToggleWrapper
                    toggleActive={setPublished}
                    isActive={isPublished}
                    dataTest='toggle'
                />
                <MoreActions
                    subsection={subsection}
                    onEdit={handleEdit}
                    onDuplicate={handleDuplicate}
                    showDeletePopup={showDeletePopup}
                    handleHideDeletePopup={handleHideDeletePopup}
                    handleShowDeletePopup={handleShowDeletePopup}
                    onDelete={handleDelete}
                    data-test='more-actions'
                />
            </ActionsWrapper>
        </ListItem>
    );
});
